'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-page-title';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function PageTitle(_ref) {
  var className = _ref.className,
      title = _ref.title;

  if (!title) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("h1", {
    className: classNames(CLASSNAME, className)
  }, title);
}
PageTitle.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Title of the page */
  title: PropTypes.string
};

module.exports = PageTitle;
